import React, { Component } from 'react'
import { Button, Input, Form, message, Select } from 'antd'
import styles from './style.module.less'
import * as utils from 'utils/index'
@Form.create()
class AddExpressForm extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // if ((values.expressCompany === '顺丰速运' || values.expressCompany === '丰网速运') && !values.mobile) {
        //   message.error('顺丰速运/丰网速运需填写收件人或寄件人手机号或手机号后四位');
        // } else {
        this.props.onSubmit(values)
        this.props.form.resetFields()
        // message.info('已添加，请记得保存!')
        // }
      }
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    let company = []
    for (var key in utils.expressCompanyCode) {
      var value = utils.expressCompanyCode[key]
      company.push({ name: value, id: value })
    }
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className={styles.addForm}>
          <Form.Item
            label="运单号"
            className={styles.cell}
            required>
            {getFieldDecorator('expressNo', {
              rules: [
                {
                  required: true,
                  message: '请输入运单号',
                },
              ],
            })(
              <Input
                className={styles.ydh}
                placeholder="请输入运单号"
              ></Input>)}
          </Form.Item>
          <Form.Item
            label="快递公司"
            className={styles.company}
            required>
            {getFieldDecorator('expressCompany', {
              rules: [
                {
                  required: true,
                  message: '请选择快递公司',
                },
              ],
            })(
              <Select showSearch optionFilterProp="title" placeholder="搜索" style={{ width: '100%' }
              }>
                {
                  company.map(ele => {
                    return <Select.Option key={ele.id} title={ele.name} value={ele.id}>{ele.name}</Select.Option>
                  })
                }
              </Select>
            )}
          </Form.Item>
          <Form.Item label="手机号" className={styles.mobile}>
            {getFieldDecorator('mobile', {
              rules: [
                {
                  required: false,
                  message: '请输入手机号后4位',
                },
              ],
            })(
              <Input
                className={styles.mobile}
                placeholder="请输入手机号后4位"
              />
            )}
            <h4><span style={{ fontSize: 10, color: 'red' }}>顺丰速运/丰网速运需填写收件人或寄件人手机号或手机号后四位</span></h4>
          </Form.Item>
          <Form.Item label="描述" className={styles.cell}>
            {getFieldDecorator('desc', {
              rules: [
                {
                  required: false,
                  message: '请输入描述',
                },
              ],
            })(
              <Input
                className={styles.desc}
                placeholder="请输入描述"
              />
            )}
          </Form.Item>
          <Form.Item className={styles.cell}>
            <Button htmlType="submit" type="primary">添加</Button>
          </Form.Item>
        </div>
      </Form>
    )
  }
}

export default AddExpressForm
